/**
 * Thin top progress bar tied to in-flight g.fetch calls.
 *
 * g.fetch reports start/end here (skip per call with opts.progress: false -
 * the component libraries do it for their chatty background loads). The bar
 * only appears when a call takes longer than SHOW_DELAY, so fast requests
 * never flash it; while visible it trickles toward 90% and completes to 100%
 * when the last in-flight call lands. Styles: src/scss/_progress.scss.
 */
const SHOW_DELAY = 200; // ms before a slow call shows the bar

let count = 0;
let bar = null;
let fill = null;
let showTimer = null;
let trickleTimer = null;
let width = 0;

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function set(w) {
	width = w;
	fill.style.width = w + '%';
}

function show() {
	if (!document.body) return;
	if (!bar) {
		bar = document.createElement('div');
		bar.className = 'genus-progress';
		bar.setAttribute('aria-hidden', 'true');
		fill = document.createElement('div');
		fill.className = 'genus-progress-bar';
		bar.appendChild(fill);
		document.body.appendChild(bar);
	}
	// reset to the left without animating backwards from a previous run
	fill.style.transition = 'none';
	set(0);
	void fill.offsetWidth;
	fill.style.transition = '';
	bar.classList.add('is-active');
	set(reduced() ? 60 : 15);
	clearInterval(trickleTimer);
	if (!reduced()) {
		trickleTimer = setInterval(() => {
			if (width < 90) set(width + (90 - width) * 0.08 + 0.4);
		}, 300);
	}
}

export function progressStart() {
	count++;
	if (count > 1) return;
	clearTimeout(showTimer);
	showTimer = setTimeout(show, SHOW_DELAY);
}

export function progressEnd() {
	count = Math.max(0, count - 1);
	if (count) return;
	clearTimeout(showTimer);
	clearInterval(trickleTimer);
	if (!bar || !bar.classList.contains('is-active')) return;
	set(100);
	setTimeout(() => {
		if (!count) bar.classList.remove('is-active'); // a new call may have re-shown it
	}, reduced() ? 0 : 250);
}
